"use strict";

require("core-js/modules/es6.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  GLOBAL_SHARED_STATE_KEY: true,
  BROWSER_EVENTS_ATTACHED_KEY: true
};
exports.GLOBAL_SHARED_STATE_KEY = exports.BROWSER_EVENTS_ATTACHED_KEY = void 0;
var _taxonomy = require("./taxonomy");
Object.keys(_taxonomy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _taxonomy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _taxonomy[key];
    }
  });
});
// Note that `nwa` currently hardcodes this key to access our state. Don't
// change this unless you absolutely know what you're doing.
var GLOBAL_SHARED_STATE_KEY = '__nwAnalyticsState';
exports.GLOBAL_SHARED_STATE_KEY = GLOBAL_SHARED_STATE_KEY;
var BROWSER_EVENTS_ATTACHED_KEY = '__browserEventsAttached';
exports.BROWSER_EVENTS_ATTACHED_KEY = BROWSER_EVENTS_ATTACHED_KEY;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJHTE9CQUxfU0hBUkVEX1NUQVRFX0tFWSIsIkJST1dTRVJfRVZFTlRTX0FUVEFDSEVEX0tFWSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSAnLi90YXhvbm9teSc7XG5cbi8vIE5vdGUgdGhhdCBgbndhYCBjdXJyZW50bHkgaGFyZGNvZGVzIHRoaXMga2V5IHRvIGFjY2VzcyBvdXIgc3RhdGUuIERvbid0XG4vLyBjaGFuZ2UgdGhpcyB1bmxlc3MgeW91IGFic29sdXRlbHkga25vdyB3aGF0IHlvdSdyZSBkb2luZy5cbmV4cG9ydCBjb25zdCBHTE9CQUxfU0hBUkVEX1NUQVRFX0tFWSA9ICdfX253QW5hbHl0aWNzU3RhdGUnO1xuZXhwb3J0IGNvbnN0IEJST1dTRVJfRVZFTlRTX0FUVEFDSEVEX0tFWSA9ICdfX2Jyb3dzZXJFdmVudHNBdHRhY2hlZCc7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7QUFBQTtFQUFBO0VBQUE7RUFBQTtFQUFBO0lBQUE7SUFBQTtNQUFBO0lBQUE7RUFBQTtBQUFBO0FBRUE7QUFDQTtBQUNPLElBQU1BLHVCQUF1QixHQUFHLG9CQUFvQjtBQUFDO0FBQ3JELElBQU1DLDJCQUEyQixHQUFHLHlCQUF5QjtBQUFDIn0=